
import { FaHandHoldingHeart, FaHandshake, FaGraduationCap, FaDonate } from 'react-icons/fa';

import bgImg from '../assets/help-1265227_1280.jpg'
import volunteers from '../assets/The-Career-Benefits-of-Volunteering-During-Your-Job-Search-2-removebg-preview.png'
import YouTube from 'react-youtube';
import { Link } from 'react-router-dom';

const HistoryComponent = () => {


    const opts = {
        height: '400px',
        width: '100%',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    return (
        <>
            <section className="my-[4rem]">

                <section className='lg:w-[70%] md:w-[90%] sm:w-[100%]  lg:m-auto md:m-auto sm:m-0 px-2 py-2 mb-4'>

                    <h1 className='text-[30px] font-bold text-center pb-2 uppercase touch-pan-up'>Histoire de ONFEJ</h1>
                    <div className='flex justify-center align-middle items-center gap-4 my-2'>
                        <span className='w-[10%] h-[2px] bg-orange-400'></span>
                        <span className='uppercase font-bold text-[16px]'>ONFEJ</span>
                        <span className='w-[10%] h-[2px] bg-orange-400'></span>
                    </div>

                    <p className='text-justify px-4 py-3'>
                        En 2012, l'Organisation Nationale pour la Formation et l'épanouissement de la Jeunesse (ONFEJ) est créée, son Coordonnateur Général et Fondateur a été un pionnier au tout début.

                        Notre mission est de promouvoir l'éducation, le leadership personnel et l'autonomie des jeunes en Haïti.

                        Notre vision est de créer un développement basé sur l’éducation et axé sur la jeunesse.

                        Nous pensons que l'éducation est la base de tout développement ; notre pays souffre depuis des décennies d’un manque de formation, la jeunesse est le pilier du progrès et doit en être le moteur.

                        Nous voulons motiver les jeunes à prendre conscience et à agir rapidement. «Tant vaut l'éducation, tant la nation.»
                    </p>

                    <p className='text-justify px-4 py-3'>
                        <b>
                            Nos projets sont
                        </b>
                        <ul className='list-disc leading-8 px-6'>

                            <li>
                                Formation au leadership pour les jeunes de tous les pays

                            </li>
                            <li>

                                Créer au moins une bibliothèque de leadership
                            </li>
                            <li>

                                Aider les jeunes à étudier à l’université
                            </li>
                            <li>

                                Former les jeunes en anglais
                            </li>

                            <li>

                                En guise de réalisation, nous avons commencé avec Génie Révolution : 4 éditions de ce concours réalisées à destination des écoliers et étudiants universitaires
                            </li>
                            <li>

                                Accompagnement des étudiants et de ceux en échec ; orientation professionnelle (pendant 6 ans).
                            </li>
                        </ul>
                    </p>


                    <div className="my-4 grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 justify-center  gap-4">

                        <div className='px-3 py-3 '>
                            <YouTube
                                videoId={`6ycHAhZSm_I?si=cOzsBfZJniL3KsLp`}                  // defaults -> ''
                                id={`6ycHAhZSm_I?si=cOzsBfZJniL3KsLp`}                       // defaults -> ''
                                className={``}                // defaults -> ''
                                iframeClassName={`bg-gray-100 rounded-md`}          // defaults -> ''
                                style={{}}                    // defaults -> {}
                                title={``}                    // defaults -> ''
                                loading={``}                  // defaults -> undefined
                                opts={opts}                        // defaults -> {}
                                onReady={() => {

                                }}                    // defaults -> noop
                                onPlay={() => {

                                }}                     // defaults -> noop
                                onPause={() => {

                                }}                    // defaults -> noop
                                onStateChange={() => {

                                }}              // defaults -> noop
                                onPlaybackRateChange={() => {

                                }}       // defaults -> noop
                                onPlaybackQualityChange={() => {

                                }}    // defaults -> noop
                            />
                        </div>

                        <div className='px-3 py-3'>
                            <h1 className='py-4 text-[18px] text-justify font-bold capitalize'>
                                Bien former pour assurer le développement.
                            </h1>

                            <p className='text-[15px] py-2'>
                                Nous avons organisé des conférences sur l'entrepreneuriat, accordé des prêts aux jeunes pour lancer des entreprises,
                                dispensé des formations en leadership et en développement personnel. D'autres formations sur des sujets économiques
                                d'actualité comme la crise du dollar ont été réalisées.
                            </p>

                            <p className='text-[15px] py-2'>
                                En 2016, nous avons lancé une initiative baptisée SUCCÈS POUR TOUS, notre objectif était de former une cinquantaine
                                de jeunes pendant 8 semaines dans différents domaines comme les nouvelles technologies informatiques, le management,
                                l'entrepreneuriat, le leadership, le métier de formateur, les ressources humaines etc. Mais surtout,
                                pour encadrer et accompagner ces jeunes en grande partie pour appliquer ce qu'ils ont appris et le transmettre aux autres.
                            </p>
                            <p className='text-[15px] py-2'>
                                En 2017, notre deuxième édition du même programme s'est élargie, touchant plus d'un millier de jeunes et de
                                professionnels en personne et plusieurs dizaines de milliers en ligne. Nous avons eu des conférenciers renommés
                                de tous les domaines.
                            </p>
                           
                        </div>

                    </div>


                </section>


                <section className='lg:w-[70%] md:w-[90%] sm:w-[100%]  lg:m-auto md:m-auto sm:m-0 px-4 py-2 mb-4 text-justify'>
                    <p className='text-[15px] py-2'>
                        Fin 2017, nous avons essayé d'élargir le cadre en touchant des intervenants internationaux, cela s'est avéré difficile et depuis, nous avons mené des activités isolées comme une formation sur l'entrepreneuriat en décembre 2018.
                    </p>

                    <p className='text-[15px] py-2'>
                        En 2020, pendant la période du coronavirus, nous avons essayé de reprendre nos activités mais les difficultés du pays et le manque de ressources disponibles nous ont toujours fait défaut.
                    </p>

                    <p className='text-[15px] py-2'>
                        Parallèlement, nous avons continué à promouvoir l'éducation en vendant des livres et en organisant des séminaires. Nous avons même lancé le grand projet intitulé 1000 projets pour Haïti.
                    </p>

                    <p className='text-[15px] py-2'>
                        Durant toutes ces années difficiles, parallèlement aux activités sociales nous avons créé des petites et moyennes entreprises,
                         participé à des concours, effectué des voyages à l'étranger pour mieux nous former, etc. Nous comptons aujourd'hui une dizaine
                          d' entreprises dans le groupe et nous entretenons de bonnes relations avec le leader mondial. Robin Sharma avec qui nous avons
                           suivi une formation importante à Toronto, Canada, en 2015. <br/>

                        En 2022, notre projet phare ressuscite avec HAITI NEVER GIVE UP, nous avons trouvé la bonne formule : 
                        celle d'emprunter la voix de célébrités et de personnalités mondiales dans divers domaines pour insuffler aux jeunes 
                        haïtiens un nouveau souffle d'engagement, de résilience, de créativité. impact positif dans leur vie, développement
                         de nouveaux réflexes afin de toujours dépasser leurs limites. Malgré nos efforts et la confirmation d'intervenants de renom, 
                        le contexte du pays ne l'a pas permis.<br />

                        {/* En 2023, nous avons reformaté et réorienté le projet HAITI NEVER GIVE UP vers ce que vous pouvez lire actuellement sur ce site,
                         découvrez ce qui se passe derrière cette belle initiative */}
                    </p>
                </section>

                <section
                    style={{
                        background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url(${bgImg})`,
                        backgroundSize: "cover",
                        objectFit: "cover",
                        backgroundRepeat:'no-repeat' ,
                        backgroundAttachment:'fixed'
                    }}
                    className="lg:h-[650px] md:h-[auto] sm:h-[auto] mt-[2rem]">

                    <div className='lg:w-[50%] md:w-[80%] sm:w-[100%] lg:ml-[10%]  px-4 pt-4 pb-6'>
                        <h1 className="font-bold text-[30px] text-white py-2">What you can do</h1>
                        <div className='w-[10%] h-[2px] bg-orange-300 mb-4'></div>

                        <div className=" my-6 text-black bg-white">

                            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4'>
                                <div className="px-2 py-4 flex gap-3 justify-start hover:bg-orange-50 hover:text-orange-600">

                                    <div className='px-2 py-2'>
                                        <FaDonate size={50} className='text-orange-600' />
                                    </div>

                                    <div className='px-2 py-2'>
                                        <h1 className='text-[20px] font-bold pb-2'>Donation</h1>
                                        <p>
                                            Lorem Ipsum is simply
                                            dummy text of the printing and typesetting industry.
                                            Lorem Ipsum has been the industry's standard.
                                        </p>
                                    </div>
                                </div>


                                <div className="px-2 py-4 flex gap-3 justify-start hover:bg-orange-50 hover:text-orange-600">

                                    <div className='px-2 py-2'>
                                        <FaHandshake size={50} className='text-orange-600' />
                                    </div>

                                    <div className='px-2 py-2'>
                                        <h1 className='text-[20px] font-bold pb-2'>Volunteer</h1>
                                        <p>
                                            Lorem Ipsum is simply
                                            dummy text of the printing and typesetting industry.
                                            Lorem Ipsum has been the industry's standard.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4'>
                                <div className="px-2 py-4 flex gap-3 justify-start hover:bg-orange-50 hover:text-orange-600">

                                    <div className='px-2 py-2'>
                                        <FaGraduationCap size={50} className='text-orange-600' />
                                    </div>

                                    <div className='px-2 py-2'>
                                        <h1 className='text-[20px] font-bold pb-2'>Scolarship</h1>
                                        <p>
                                            Lorem Ipsum is simply
                                            dummy text of the printing and typesetting industry.
                                            Lorem Ipsum has been the industry's standard.
                                        </p>
                                    </div>
                                </div>


                                <div className="px-2 py-4 flex gap-3 justify-start hover:bg-orange-50 hover:text-orange-600">

                                    <div className='px-2 py-2'>
                                        <FaHandHoldingHeart size={50} className='text-orange-600' />
                                    </div>

                                    <div className='px-2 py-2'>
                                        <h1 className='text-[20px] font-bold pb-2'>Foundrise</h1>
                                        <p>
                                            Lorem Ipsum is simply
                                            dummy text of the printing and typesetting industry.
                                            Lorem Ipsum has been the industry's standard.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>


                <section className='py-4 my-14 px-4 bg-gray-50 lg:h-[600px] md:h-[600px] sm:h-[auto]'>

                    <div className='lg:w-[60%] md:w-[80%] sm:w-[100%] lg:ml-[10%]  px-4 py-12  grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4'>


                        <div className=' px-4 py-6'>
                            <h1 className='text-[30px] font-bold pb-2 '>How<br />
                                can you help?</h1>
                            <div className='bg-orange-400 h-[3px] w-[15%] mb-4 mt-2'></div>

                            <p className='py-2 text-[15px]'>
                                Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée
                            </p>

                            <p className='py-2 text-[15px]'>
                                Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée
                            </p>

                            <p className='flex justify-start align-middle items-start gap-3 my-8 flex-wrap'>
                                <span className='px-6 py-1 rounded-[15px] bg-gray-100 border border-orange-400 text-[14px] font-bold'>$5</span>
                                <span className='px-6 py-1 rounded-[15px] bg-gray-100 border border-orange-400 text-[14px] font-bold'>$15</span>
                                <span className='px-6 py-1 rounded-[15px] bg-gray-100 border border-orange-400 text-[14px] font-bold'>$20</span>
                                <span className='px-6 py-1 rounded-[15px] bg-gray-100 border border-orange-400 text-[14px] font-bold'>$50</span>
                            </p>

                            <Link to={`tel:+5094823-4242`} className='px-4 py-2.5 rounded-[20px] bg-orange-600 text-white text-center font-bold'>Contactez Nous</Link>

                        </div>

                        <div className='border bg-[rgb(51,51,51)] px-10 py-6 text-white h-[390px] relative'>
                            <h3 className='text-[18px] font-bold py-2'>Total money donated</h3>
                            <h1 className='text-[32px] font-bold py-4'>112.5 Million </h1>

                            <hr className='w-[100%] m-auto py-4' />

                            <h1 className='text-[18px] font-bold py-2'>Donors</h1>
                            <h2 className='text-[32px] font-bold py-2'>54</h2>

                            <div className='absolute top-[10rem] w-[100%] h-[300px]  '>
                                <img
                                    src={volunteers}
                                    alt='volunteers'
                                    className='w-full h-full flex-shrink-0 flex-grow-0 hover:animate-pulse'
                                />
                            </div>

                        </div>



                    </div>


                </section>


            </section>

        </>
    )
}

export default HistoryComponent